import React, { useEffect, useState } from 'react'
import { useSTheme } from 'styles/theme'
import SText from '../../../opinionless/SText'
import FImage from '../../FImage'
import { SingleCardStyledContainer } from './styles'

type SingleCardData = {
    imageUrl: string
    text: string
    isChecked: boolean
    onCheckChange: (id: string, checked: boolean) => void
    id: string
}

const FCard: React.FC<SingleCardData> = (props: SingleCardData) => {
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    const [isChecked, setIsChecked] = useState(props.isChecked)

    const toggleChecked = () => {
        setIsChecked(!isChecked)
        props.onCheckChange(props.id, !isChecked)
    }

    useEffect(() => {
        setIsChecked(props.isChecked)
    }, [props.isChecked])

    return (
        <SingleCardStyledContainer
            onClick={() => toggleChecked()}
            id={props.id}
            value={props.id || ''}
            sx={{
                backgroundColor: `${isChecked ? theme.colors.secondaryColor : theme.colors.white}`,
                '&:hover': {
                    backgroundColor: `${isChecked ? theme.colors.secondaryColor : theme.colors.backgroundColor};}`,
                },
            }}
        >
            <FImage imageUrl={props.imageUrl} alt={props.text} width={'24px'} height={'24px'} />
            <SText
                sx={{
                    fontSize: '11px',
                    marginRight: '7px',
                    fontFamily: fontFamily,
                }}
                color={isChecked ? theme.colors.white : theme.colors.secondaryColor}
            >
                {props.text}
            </SText>
        </SingleCardStyledContainer>
    )
}

export default FCard
